import type {
  ActivityEntry,
  ServiceRef,
} from "@shared-core/data/supplier-portal-adapter";
import {
  activitySentence,
  activitySourceTag,
  dayMonthTime,
} from "@shared-core/domain/supplier-portal-wording";

/** The order's events, oldest first, each worded for the supplier with a tag saying how it arrived. */
export function ActivityLog({
  events,
  service,
}: {
  events: ActivityEntry[];
  service: ServiceRef | null;
}) {
  return (
    <ol className="grid gap-1.5 text-sm">
      {events.map((event, index) => {
        const tag = activitySourceTag(event);
        return (
          <li
            key={`${event.at}-${index}`}
            className="grid grid-cols-[6.5rem_minmax(0,1fr)] gap-2.5"
          >
            <time
              dateTime={event.at}
              className="text-muted-foreground tabular-nums"
            >
              {dayMonthTime(event.at)}
            </time>
            <span>
              {activitySentence(event, service)}
              {tag && (
                <span className="ml-1.5 rounded border px-1.5 text-[11px] text-muted-foreground">
                  {tag}
                </span>
              )}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
